<template>
  <tr class="shadow-lg sm:shadow-none">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: "ontick-table-tr",
};
</script>

<style></style>
